<script setup lang="ts">
const route = useRoute()
const { locale } = useI18n()

const runtimeConfig = useRuntimeConfig()

const previewSecret = runtimeConfig?.previewSecret || runtimeConfig?.public?.previewSecret
const isPreview = computed(() => route?.query?.previewSecret === previewSecret)

const { data, error } = await useAsyncData<NewsletterPage>(
  () => `newsletter-page-${locale.value}`,
  () => $fetch<NewsletterPage>('/api/payload-gql', {
    method: 'POST',
    body: {
      query: GlobalNewsletterPageQuery,
      variables: {
        locale: locale.value,
        isPreview: isPreview.value,
      },
      isPreview: isPreview.value,
    },
  })
)

if (error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: `Error fetching page`,
  })
}

// The page is built around the newsletter image, so that is also the image it
// shares with -- only falling back to the site-wide cover when there is none.
usePageSeo({
  title: () => data.value?.title || 'Newsletter',
  image: () => (data.value?.image && typeof data.value.image !== 'string' ? data.value.image : undefined),
})
</script>

<template>
  <page-layout>
    <template #header>
      <page-header
        :title="data?.title || 'Newsletter'"
        :route="{
          name: 'newsletter',
          title: data?.title,
        }"
        :include-breadcrumbs="true"
      />
    </template>

    <template #default>
      <pages-newsletter
        v-if="data"
        :data="data"
      />
    </template>
  </page-layout>
</template>
